import { Component } from '@angular/core';

@Component({
  selector: 'hip-terms-modal',
  templateUrl: './terms-modal.component.html',
  styleUrls: ['./terms-modal.component.scss'],
})
export class TermsModalComponent {}
